export default __webpack_public_path__ + "static/media/suggested-vat-account-20.bafee725.png";